<template>
	<div class="flex wrap xs-12">
		<!-- Headline -->
		<div class="fs5 lh125 fw7 c1 mb2">{{ $t("actions") }}</div>

		<!-- Body -->
		<div class="xs-12 flex">
			<div class="xs pr2">
				<j-base-select
					v-model="actionId"
					:options="actions"
					:placeholder="$t('select_action')"
				/>
			</div>
			<div>
				<j-button :isDisabled="actionId ? false : true" @click="handleAction">
					{{ $t("continue") }}
				</j-button>
			</div>
		</div>

		<!-- Action Modal -->
		<core-modal name="caseAction" :headline="modalHeadline" width="800">
			<component
				:is="actionId"
				@file:downloaded="$modal.hide('caseAction')"
				@email:sent="afterSendNotification($t('email_was_sent'))"
				@notification:sent="afterSendNotification($t('notification_was_sent'))"
			/>
		</core-modal>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JButton from "@/components/JButton/"
import JBaseSelect from "@/components/JBaseSelect/"
import CoreModal from "@/modules/core/components/CoreModal"

import ActionDownloadPDF from "./ActionDownloadPDF"
import ActionSendEmail from "./ActionSendEmail"
import ActionSendInternalNotification from "./ActionSendInternalNotification"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		JCard,
		JButton,
		JBaseSelect,
		CoreModal,

		ActionDownloadPDF,
		ActionSendEmail,
		ActionSendInternalNotification
	},

	data() {
		return {
			actionId: null,
			actions: [
				// { name: this.$t("approve_case"), value: "ActionApproveCase" },
				{ name: this.$t("download_pdf"), value: "ActionDownloadPDF" },
				{ name: this.$t("send_email"), value: "ActionSendEmail" },
				{
					name: this.$t("send_notification"),
					value: "ActionSendInternalNotification"
				}
			],
			isApproveLoading: false
		}
	},

	methods: {
		async approveCase() {
			// Query
			const query = gql`
				mutation updateCase($id: String!, $input: updateCaseInput!) {
					updateCase(id: $id, input: $input) {
						status
						errors
					}
				}
			`

			// Variables
			const variables = {
				id: this.$route.params.id,
				input: {
					status: "APPROVED"
				}
			}

			// Call
			this.isApproveLoading = true
			const res = await api({ query, variables })
			this.isApproveLoading = false

			if (
				res.data?.updateCase?.errors &&
				res.data?.updateCase?.errors?.length
			) {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text: res?.errors?.toString() || res.data?.updateCase?.errors
					}
				})
			}

			this.$store.dispatch("caseManagement/fetchCase", {
				caseId: this.$route.params.id
			})
		},

		handleAction() {
			if (this.actionId === "ActionApproveCase") {
				this.approveCase()
			} else this.$modal.show("caseAction")
		},

		afterSendNotification(text) {
			this.$modal.hide("caseAction")
			this.$store.dispatch("addMessage", {
				message: {
					type: "success",
					text
				}
			})
		}
	},

	computed: {
		modalHeadline() {
			return this.actions?.find(item => item.value === this.actionId)?.name
		}
	}
}
</script>
